<template>
    <div>
        <div class='recommended-products-title'>Recommended Products</div>
        <div class='recommended-products-container'>

            <div class="glide" id='recommended_products_slider'>
                <div class="glide__track" data-glide-el="track">
                    <ul class="glide__slides">
                        <div v-for="product in products" :key='product'>
                            <li class="glide__slide"> 
                                <!-- <RecommendedProductCard :product='product'/> -->
                                <ProductCard :product='product'/>
                            </li>
                        </div>
                    </ul>
                </div>
                <div class="glide__arrows" data-glide-el="controls">
                    <button class="change-image-arrow left" data-glide-dir="<"><i class="fa-solid fa-chevron-left"></i></button>
                    <button class="change-image-arrow right" data-glide-dir=">"><i class="fa-solid fa-chevron-right"></i></button>
                </div>
                  <!-- <div class="glide__bullets" data-glide-el="controls[nav]">
                    <template v-for='(product, index) in products' :key="product">
                        <button class="glide__bullet" :data-glide-dir="'='+index"></button>
                    </template>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import {checkAuth} from "@/global/modules/functions.js";
import "@glidejs/glide/dist/css/glide.core.css";
import "@glidejs/glide/dist/css/glide.theme.css";

import RecommendedProductCard from '@/ecom/components/products/single_product/recommended_products/RecommendedProductCard.vue';
import ProductCard from '@/ecom/components/products/ProductCard.vue';
import Glide from '@glidejs/glide' 

export default {
    components: {RecommendedProductCard, ProductCard},
    data(){
        return{
            products: [],
            glide_instance_rec: null
        }
    },
    methods:{
        async getRecommendedProducts(){
            let response = await fetch(`/api/elastic-search/products?search_string=dress&search_type=fuzzy&start_index=0&fetch_next=10`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.products = results.products;
                setTimeout(() => {
                       if(document.getElementById('recommended_products_slider') != null){
                            this.glide_instance_rec = new Glide('#recommended_products_slider',{type: 'carousel', perView: 5, gap: 50,
                                breakpoints: {
                                    1600: {
                                        perView: 4
                                    },
                                    // 1650: {
                                    //     perView: 5
                                    // },
                                    1140: {
                                        perView: 3
                                    },
                                    860: {
                                        perView: 2
                                    },
                                    768: {
                                        perView: 1
                                    }
                                }
                            }).mount();
                       }
                }, 1);
            }
        },
    },
    mounted(){
        this.getRecommendedProducts();
    }
}
</script>

<style lang="scss" scoped>
.recommended-products-title{
    font-size: 2rem;
    color: var(--black);
    margin-bottom: 15px;
    text-align: center;
}
.recommended-products-container{
    display: flex;
    justify-content: center;
}

.glide__arrows{
    position: absolute;
    top: 30%;
    display: flex;
    width: 100%;
    justify-content: space-between;
}

.change-image-arrow{
    border: none;
    background-color: transparent;
    font-size: 2rem;
    cursor: pointer;
    color: #343a40;
}
.change-image-arrow.left{
    margin-left: -40px;
}
.change-image-arrow.right{
    margin-right: -40px;
}
.glide{
    width: 90%;

    @media(max-width: 768px) {
         width: var(--product-card-width);
    }
    // width:1200px;
}
</style>